export default __webpack_public_path__ + "static/media/goodcampaignnames.1fd2b235.jpg";